// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { isDefined } from '@utilities';

// Import style for web component
const styles = require( './web-component-style.scss' );

// eslint-disable-next-line require-jsdoc
@customElement( 'lfm-faq-placeholder' )
export class FAQPlaceholder extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	@property({ type: String }) width;
	@property({ type: String }) height;

	// eslint-disable-next-line require-jsdoc
	constructor() {
		super();
	}

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div 
				class="placeholder"
				style="
					${ isDefined( this.width ) ? `width: ${ this.width };` : '' }
					${ isDefined( this.height ) ? `height: ${ this.height };` : '1em' }
				"
			></div>
		`;
	}
}